import { ACTION_TYPES, Advantage, Contract, ImpactsSimulation } from '@app-types/simulator/simulator';

export function getFamilyContract(simulation: ImpactsSimulation | undefined): Contract[] {
    if (!simulation) {
        return [];
    }

    const contractsForFamily =
        simulation?.contracts?.filter((c) => c.applicableOp.advantages?.some((a) => familyAdvantagesPredicate(a))) ||
        [];
    const currentOrderFamily = simulation?.currentCommercialOrders?.filter((order) =>
        order.mainOffers.some((offer) => offer.advantages?.some((a) => familyAdvantagesPredicate(a))),
    );
    const currentOrderToContract: Contract[] =
        currentOrderFamily?.flatMap((order) =>
            order.mainOffers?.map((offer) => ({ id: order.orderId, applicableOp: offer })),
        ) || [];

    return [...contractsForFamily, ...currentOrderToContract];
}

export function familyAdvantagesPredicate(advantage: Advantage): boolean {
    return (
        advantage.familyPack &&
        (advantage.action === ACTION_TYPES.CONSERVATION || advantage.action === ACTION_TYPES.SOUSCRIPTION)
    );
}
